import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  SimulationTrackerState,
} from 'src/app/state/simulation-tracker/simulation-tracker.state';

import { SimulationTrackerActions } from 'src/app/state/simulation-tracker/simulation-tracker.actions';
import { SimulationTracker } from '../../interfaces/simulation-tracker';
import { SimulationTrackerStatus } from '../../enums/simulation-tracker-status';

@Component({
  selector: 'app-simulation-tracker',
  templateUrl: './simulation-tracker.component.html',
  styleUrl: './simulation-tracker.component.scss',
})
export class SimulationTrackerComponent implements OnInit {
  constructor(private store: Store, private cdr: ChangeDetectorRef) {}

  @Select(SimulationTrackerState.simulationTrackers)
  simulationTrackers$!: Observable<SimulationTracker[]>;

  tableColumns: { field: string | string[]; label: string; format?: string }[] =
    [
      { field: 'created', label: 'Created', format: 'date' },
      { field: 'studyAreaName', label: 'Study Area Name' },
      { field: 'simulationTrackerId', label: 'ID' },
      { field: 'simulationName', label: 'Simulation Name' },
      { field: 'userName', label: 'Username' },
      { field: 'status', label: 'Status' },
      { field: 'deleted', label: 'Deleted' },
    ];

  ngOnInit(): void {
    this.store.dispatch(new SimulationTrackerActions.GetSimulationTrackers());
  }

  getValue(
    obj: Record<string, string | SimulationTrackerStatus | Date | boolean>,
    field: string
  ): string | number {
    const value: string | SimulationTrackerStatus | Date | boolean = obj[field];

    if (typeof value === 'string' || typeof value === 'number') {
      return value;
    }

    return String(value);
  }
}
